import React, { useState, useEffect } from "react";
import {
  TextField,
  Typography,
  FormControlLabel,
  Link,
} from "@material-ui/core";
import ActionButton from "../../components/ActionButton";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import PropertyNames from "../../PropertyNames";
import { useSelector, useDispatch } from "react-redux";
import "filepond/dist/filepond.min.css";
import axios from "../../AxiosClient";
import JobProgress from "../components/JobProgress";
import MaterialTable from "@material-table/core";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";
import { useHistory } from "react-router-dom";
import AreYouSureDialog from "../../components/dialog/AreYouSureDialog";
import Checkbox from "@material-ui/core/Checkbox";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 15,
    display: "flex",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  flexContainer: {
    display: "flex",
  },
  inputFields: {
    display: "flex",
    flexDirection: "row",
  },
}));

function CreateNewCronSchedule(props) {
  const [saving, setSaving] = useState(false);
  const classes = useStyles();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const history = useHistory();
  // const [cronExpression, setCronExpression] = useState("");
  const [newScheduleName, setNewScheduleName] = useState("");
  const [newScheduleDescription, setNewScheduleDescription] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ksIds, setKsIds] = useState([]);
  const [schedule, setSchedule] = useState(null);
  const [saveDialog, setSaveDialog] = useState(false);
  const [isFullReindex, setIsFullReindex] = useState(false);

  useEffect(() => {
    axios.get("/knowledgesource/",{ withCredentials:true }).then((res) => {
      let data = res.data.content.filter((ks) => {
        return ks.type !== "EXPERT";
      });

      setData(
        data.map((i) => {
          return { id: i.sourceId, data: i };
        })
      );
      setLoading(false);
    });
  }, []);

  const createNewSchedule = () => {
    setSaving(true);
    let cronString = "";
    props.cronExpression.map((item) => {
      cronString = cronString + item + " ";
    });
    axios
      .post("/knowledgesource/batchreindex/", {
        scheduleName: newScheduleName,
        scheduleDescription: newScheduleDescription,
        cronExpression: cronString,
        knowledgeSourceIds: ksIds,
        isFullReindex: isFullReindex,
      })
      .then(() => {
        enqueueSnackbar(t("schedule_successfully_created"), {
          variant: "success",
        });
        setSaving(false);
        setSaveDialog(false);
        setNewScheduleName("");
        setNewScheduleDescription("");
        // setCronExpression("");
        setKsIds([]);
        props.updateList();
      })
      .catch((err) => {
        enqueueSnackbar(t("error_creating_schedule"), {
          variant: "error",
        });
        setSaving(false);
      });
  };

  const knowledgeSourceSelected = (rows) => {
    setKsIds(rows.map((row) => row.id));
  };

  const [columns] = useState([
    {
      title: "id",
      field: "data.sourceId",
      hidden: true,
    },
    {
      title: t("manage_ks_description_table_header"),
      field: "data.description",
    },
    {
      title: t("global_topic"),
      field: "data.topicName",
    },
    {
      title: t("manage_ks_type_table_header"),
      field: "data.type",
      lookup: {
        EXPERT: "Expert",
        GOOGLE_DRIVE: "Google Drive",
        FILE_SHARE: "File Share",
        SHAREPOINT: "SharePoint",
        SALESFORCE: "Salesforce",
        WEBSITE: "Website",
        DROPBOX: "Dropbox",
        ONEDRIVE: "OneDrive",
      },
    },
    {
      title: t("manage_ks_indexed"),
      type: "boolean",
      render: (rowData) => {
        if (rowData.data.isQueued || rowData.data.isBeingIndexed) {
          return <JobProgress triggerName={rowData.data.jobTriggerName} />;
        }
        if (
          !rowData.data.dateReindexed ||
          rowData.data.dateReindexed === "1970-01-01 00:00:00"
        ) {
          return <ClearIcon />;
        }
        return <DoneIcon />;
      },
    },
    {
      title: t("manage_ks_last_indexed"),
      field: "data.dateReindexed",
      type: "datetime",
      editable: "never",
      render: (rowData) => {
        if (rowData.data.dateReindexed === 0) {
          return null;
        }
        return rowData.data.dateReindexed;
      },
    },
  ]);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h5" style={{ marginRight: 10 }}>
          {t("create_new_schedule")}
        </Typography>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={() => setSaveDialog(true)}
          loading={saving}
          disabled={props.cronExpression === ""}
        >
          {t("global_save")}
        </ActionButton>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={props.openCron}
          style={{ marginLeft: "10px" }}
        >
          {"Select interval"}
        </ActionButton>
      </div>
      <div className={classes.inputFields}>
        <TextField
          style={{ marginRight: 10 }}
          required
          value={newScheduleName}
          onChange={(title) => setNewScheduleName(title.target.value)}
          label={t("schedule_name")}
        />
        <TextField
          style={{ marginRight: 10 }}
          value={newScheduleDescription}
          onChange={(description) =>
            setNewScheduleDescription(description.target.value)
          }
          label={t("schedule_description")}
        />
        <FormControlLabel
          style={{ marginRight: 20 }}
          value="isFullReindex"
          control={
            <Checkbox
              checked={isFullReindex}
              onChange={() => setIsFullReindex(!isFullReindex)}
              value={t("global_full_reindex") + "?"}
            />
          }
          label={t("global_full_reindex") + "?"}
        />
        <Typography variant="subtitle1" style={{ marginTop: "10px" }}>
          {props.cronExpressionString}
        </Typography>
        {/* <Link
          style={{ marginTop: 15 }}
          href="https://support.kpsol.com/support/crongenerator/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Click here to go to the cron expression generator
        </Link> */}
      </div>
      {/* <Scheduler
        cron={cronExpression}
        setCron={setCronExpression}
        setCronError={setCronError}
        isAdmin={true}
      /> */}

      <div
        style={{
          overflow: "auto",
          padding: 10,
          height: "100%",
          marginTop: 10,
        }}
      >
        <MaterialTable
          isLoading={loading}
          columns={columns}
          data={data}
          onSelectionChange={knowledgeSourceSelected}
          options={{
            pageSize: 10,
            pageSizeOptions: [5, 10, 15, 20],
            filtering: true,
            headerStyle: { position: "sticky", top: 0 },
            actionsColumnIndex: -1,
            selection: true,
          }}
          onRowClick={(_event, _rowData, togglePanel) => {
            // togglePanel();
          }}
          title={t("global_knowledge_source_plural")}
        />
      </div>
      <AreYouSureDialog
        open={saveDialog}
        onClose={() => setSaveDialog(false)}
        onSubmit={createNewSchedule}
      >
        {t("are_you_sure_create_schedule")}
      </AreYouSureDialog>
    </div>
  );
}

export default CreateNewCronSchedule;
